/**
 * Iter 31.212 — DemoBanner
 *
 * Persistent strip at the top of every authenticated page when the
 * current user is the demo visitor (role === "demo"). Reads from
 * the saved session, no extra API call. Reset button calls
 * /api/demo/reset (the one write the demo role IS permitted to make).
 */
import React, { useState } from "react";
import { api, getUser } from "@/lib/api";
import { RefreshCw, Eye } from "lucide-react";

export default function DemoBanner() {
    const user = getUser();
    const [resetting, setResetting] = useState(false);
    if (!user || user.role !== "demo") return null;

    const handleReset = async () => {
        if (resetting) return;
        setResetting(true);
        try {
            await api.post("/demo/reset");
            window.location.reload();
        } catch (_) {
            setResetting(false);
        }
    };

    return (
        <div
            className="w-full bg-stamp-red text-paper px-4 py-2 flex items-center justify-between gap-3 border-b border-stamp-red-dark"
            data-testid="demo-banner"
        >
            <div className="flex items-center gap-2 font-heading text-[10px] tracking-[0.22em] uppercase">
                <Eye className="w-3 h-3" />
                <span>Demo Mode · Read-Only</span>
                <span className="opacity-70 hidden sm:inline">— writes are blocked; sign up to file your own</span>
            </div>
            <button
                type="button"
                onClick={handleReset}
                disabled={resetting}
                data-testid="demo-banner-reset"
                className="font-heading text-[10px] tracking-[0.22em] uppercase border border-paper/40 px-2 py-1 hover:bg-paper hover:text-stamp-red transition-colors inline-flex items-center gap-1.5 disabled:opacity-50"
            >
                <RefreshCw className={`w-3 h-3 ${resetting ? "animate-spin" : ""}`} />
                {resetting ? "Resetting..." : "Reset"}
            </button>
        </div>
    );
}
